import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid';

const GEOStatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = 'text-blue-600',
  iconBg = 'bg-blue-50',
  valueColor = 'text-blue-600',
  change = null,
  changeLabel = 'vs last period',
  loading = false
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 animate-pulse" role="region" aria-label={`${title} loading`}>
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="h-3 bg-gray-200 rounded w-20 mb-3"></div>
            <div className="h-8 bg-gray-200 rounded w-16 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
        </div>
      </div>
    );
  }

  const isPositive = change !== null && change > 0;
  const isNegative = change !== null && change < 0;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 hover:shadow-md transition-shadow" role="region" aria-label={`${title}: ${value}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-sm font-medium text-gray-500 truncate">{title}</h2>
          <p className={`mt-2 text-3xl font-bold ${valueColor}`} aria-live="polite">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
          {subtitle && (
            <p className="mt-1 text-xs text-gray-400">{subtitle}</p>
          )}
          {change !== null && (
            <div className="mt-2 flex items-center gap-1" aria-label={`${Math.abs(change)}% ${isPositive ? 'increase' : 'decrease'} ${changeLabel}`}>
              {isPositive && (
                <ArrowUpIcon className="h-3 w-3 text-emerald-500" aria-hidden="true" />
              )}
              {isNegative && (
                <ArrowDownIcon className="h-3 w-3 text-red-500" aria-hidden="true" />
              )}
              <span className={`text-xs font-medium ${isPositive ? 'text-emerald-500' : isNegative ? 'text-red-500' : 'text-gray-400'}`}>
                {isPositive ? '+' : ''}{change}%
              </span>
              <span className="text-xs text-gray-400">{changeLabel}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`p-2.5 ${iconBg} rounded-lg flex-shrink-0`} aria-hidden="true">
            <Icon className={`h-6 w-6 ${iconColor}`} />
          </div>
        )}
      </div>
    </div>
  );
};

export default GEOStatCard;
